import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { canCreateEvent } from 'utils/userHelpers';

import React from 'react';

import { H2, P } from '@thinkific/toga-react';

import { useCommunityContext } from 'components/CommunityContext';

import styles from './EmptyState.module.scss';

const cx = classNames.bind(styles);

/* This is the empty state that will appear for events if the creator has created an event at some point */
const EmptyState = () => {
  const { t } = useTranslation();
  const { currentUser } = useCommunityContext();

  return (
    <div className={cx('events__empty-state')}>
      {canCreateEvent(currentUser) ? (
        <>
          <H2 data-qa="empty-state__title">
            {t(
              'components-events-emptyState-no_scheduled_events_header',
              `Increase student engagement with live events`
            )}
          </H2>
          <P>
            {t(
              'components-events-emptyState-create_events_to_kickstart_engagement_description',
              'Turn your Community into a classroom with engaging, dynamic learning experiences — all in one place. You can connect and engage your students through live events like:'
            )}
          </P>
          <ul>
            <li>{t('components-events-emptyState-first_item', 'Regular coaching calls')}</li>
            <li>{t('components-events-emptyState-second_item', 'Weekly check-ins')}</li>
            <li>{t('components-events-emptyState-third_item', 'Live lessons or workshops')}</li>
            <li>{t('components-events-emptyState-fourth_item', 'Interactive Q&A')}</li>
          </ul>
          <P>
            {t(
              'components-events-emptyState-call_to_action',
              'Create a live event and invite your students to add even more value to their learning experience.'
            )}
          </P>
          <P>
            {t(
              'components-events-emptyState-rsvp_message',
              "Community members can RSVP to let you know they're interested in attending, helping you plan and optimize your content and event schedule."
            )}
          </P>
        </>
      ) : (
        <>
          <H2 data-qa="empty-state__title">
            {t(
              'components-events-emptyState-no_live_events_scheduled_header',
              `No live events have been scheduled yet.`
            )}
          </H2>
          <P>
            {t(
              'components-events-emptyState-check_back_live_events_description',
              'Check back here for dynamic, live learning opportunities.'
            )}
          </P>
        </>
      )}
    </div>
  );
};

export default EmptyState;
